<template>
  <div class="container">
    <div v-for="(optionValue, optionKey) in options">
      <input
        v-model="checkboxValue"
        :value="parseInt(optionKey)"
        type="checkbox"
        :id="optionKey"
        hidden
      />
      <label :for="optionKey"> {{ $t(optionValue) }} </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomScheduleDayButtonCheckbox',
  props: {
    options: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    checkboxValue: {
      get() {
        return this.model.send_days
      },

      set(value) {
        // When send interval is months only one day of the week can be selected
        if (this.model.send_interval === 'months') {
          this.model.send_days = value.filter(
            val => !this.model.send_days.includes(val)
          )
          return
        }
        this.model.send_days = value
      }
    }
  },
  watch: {
    'model.send_interval': {
      handler(value) {
        if (value === 'months') {
          this.model.send_days = []
          return
        }
        this.model.send_days = [1, 2, 3, 4, 5, 6, 7]
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  width: 324px;
}
label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  background: #f2f5f9;
  cursor: pointer;
  border-radius: 50%;
}
input:checked ~ label {
  background: #1c87c8;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/CustomScheduleDayButtonCheckbox.vue